import { render, staticRenderFns } from "./TopicDetail.vue?vue&type=template&id=90389c9a&scoped=true"
import script from "./TopicDetail.vue?vue&type=script&lang=js"
export * from "./TopicDetail.vue?vue&type=script&lang=js"
import style0 from "./TopicDetail.vue?vue&type=style&index=0&id=90389c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90389c9a",
  null
  
)

export default component.exports